import QRCode from "qrcode.react";
import { useProfile, useReissueQrCode } from "../api/hooks";
import { Container, Row, Col } from "react-bootstrap";
import ButtonWrapper from "./ButtonWrapper";

const QRCodePanel = () => {
  const { data: profile, isLoading, error } = useProfile();
  const reissueQrCodeMutation = useReissueQrCode();

  const renderContent = () => {
    if (isLoading) {
      return <div>Loading QR Code...</div>;
    }

    if (error) {
      return <div>Error loading profile: {error.message}</div>;
    }

    if (!profile) {
      return <div>No profile data available</div>;
    }

    return (
      <>
        <Row className="justify-content-center mb-4">
          <Col xs="auto">
            {profile.uid && (
              <QRCode
                value={profile.uid}
                size={300}
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"L"}
                includeMargin={false}
                renderAs={"svg"}
              />
            )}
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs={12} sm={8} md={6} lg={4}>
            <ButtonWrapper
              buttonText="Re-issue QR Code"
              fullWidth={true}
              onClick={() => reissueQrCodeMutation.mutate()}
              disabled={reissueQrCodeMutation.isPending}
            />
          </Col>
        </Row>
      </>
    );
  };

  return (
    <Container className="px-5 mb-2">
      <Row className="my-5">
        <Col>
          <h2 className="text-center">Your QR Code</h2>
        </Col>
      </Row>
      <div className="text-center">
        {renderContent()}
      </div>
    </Container>
  );
};

export default QRCodePanel;
